import React, { useEffect, useState } from 'react'
import ModalWrapper from '../../../../../../Components/CustomModal/ModalWrapper'
import { useDispatch, useSelector } from 'react-redux'
import { getReceiveAccRej } from '../../../../../../Store/prosafe/proTransaction/PurReceive/AccRej/ReceiveAccRejList';
import axios from 'axios';
import { V_URL } from '../../../../../../BaseUrl';
import toast from 'react-hot-toast';

const AccRejModel = ({ modal, selectedItem, setSelectedItem }) => {

    const dispatch = useDispatch();
    const itemData = useSelector((state) => state?.getReceiveAccRej?.user?.data) || {};
    const [tableData, setTableData] = useState([]);
    const [disable, setDisable] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        if (selectedItem) {
            dispatch(getReceiveAccRej({ formData: { id: selectedItem } }))
        }
    }, [selectedItem, modal]);

    useEffect(() => {
        if (itemData?.items_details?.length) {
            const transformed = itemData.items_details
                // .filter((e) => e?.status !== false)
                .map((item) => ({
                    ...item,
                    acc_qty: item.acc_qty || "",
                    rej_qty: item.quantity - (item.acc_qty || 0),
                    accrej_remarks: item.accrej_remarks || "",
                    error: "",
                }))
                .sort((a, b) => {
                    if (a.status === false && b.status !== false) return 1;
                    if (a.status !== false && b.status === false) return -1;
                    return 0;
                });
            setTableData(transformed);
        }
    }, [itemData]);

    useEffect(() => {
        if (!modal.isShown) {
            setSelectedItem(null);
            setTableData([]);
        }
    }, [modal.isShown]);

    const handleAccQtyChange = (index, value) => {
        const updated = [...tableData];
        const accQty = value === "" ? "" : Number(value);
        const totalQty = updated[index].quantity;

        updated[index].acc_qty = accQty;
        updated[index].rej_qty = totalQty - accQty >= 0 ? totalQty - accQty : 0;
        if (accQty > totalQty) {
            updated[index].error = "Accepted quantity cannot exceed total quantity.";
        } else {
            updated[index].error = "";
        }
        setTableData(updated);
    };

    const handleRemarksChange = (index, value) => {
        const updated = [...tableData];
        updated[index].accrej_remarks = value;
        setTableData(updated);
    };

    const handleSubmit = () => {
        const hasErrors = tableData.some(item => item.error);
        if (hasErrors) {
            toast.error("Please fix validation errors before submitting.");
            return;
        }

        const hasAtLeastOneEntry = tableData.some(item =>
            (item.acc_qty !== "" && item.acc_qty !== null && item.acc_qty !== undefined && Number(item.acc_qty) > 0)
        );

        if (!hasAtLeastOneEntry) {
            toast.error("Please enter at least one Accepted or Rejected quantity.");
            return;
        }
        const filteredData = tableData.filter(item => item.acc_qty !== "" && item.acc_qty !== null && item.acc_qty !== undefined);
        const submitPayload = filteredData.map(item => ({
            _id: item._id,
            acc_qty: item.acc_qty,
            rej_qty: item.rej_qty,
            accrej_remarks: item.accrej_remarks,
        }));
        setDisable(true);
        const formData = new URLSearchParams();
        formData.append("id", selectedItem);
        formData.append("items_details", JSON.stringify(submitPayload));
        axios({
            method: "PUT",
            url: `${V_URL}/prosafe/pro-accept-pu-item`,
            data: formData,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
            },
        }).then((response) => {
            if (response.data.success === true) {
                modal.hide();
                setSelectedItem(null);
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
        }).catch((error) => {
            toast.error(error?.response?.data?.message || "Something went wrong");
        }).finally(() => {
            setDisable(false);
        });
    };

    const highlightText = (text, highlight) => {
        if (!highlight) return text;
        const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
        return parts.map((part, i) =>
            part.toLowerCase() === highlight.toLowerCase() ? (
                <mark key={i} style={{ backgroundColor: '#ffc107', padding: 0 }}>{part}</mark>
            ) : (
                part
            )
        );
    };

    return (
        <ModalWrapper
            title="Acc/Rej Items Details"
            isShown={modal.isShown}
            hide={modal.hide}
            footer={false}
            size='xl'
        >
            <div className='row'>
                <div className='mb-3 col-md-4'>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search Item Name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>
            <div className='row'>
                <div className="table-responsive">
                    <table className="table border-0 custom-table comman-table  mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Sr.</th>
                                <th>Item Name</th>
                                <th>Quantity</th>
                                <th>Accepted Qty</th>
                                <th>Rejected Qty</th>
                                <th>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData &&
                                tableData?.filter(item => item.item_name.toLowerCase().includes(searchTerm.toLowerCase())).length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="text-center text-muted py-3">
                                        No data found
                                    </td>
                                </tr>
                            ) : (
                                tableData
                                    ?.filter(item => item.item_name.toLowerCase().includes(searchTerm.toLowerCase()))
                                    ?.map((item, index) => (
                                        <tr key={item._id || index} style={{ backgroundColor: item.status === false ? '#f8d7da' : 'inherit' }}>                                            <td>{index + 1}</td>
                                            <td>
                                                <div>
                                                    <span
                                                        style={{
                                                            backgroundColor: item.status === false ? '#f5c6cb' : '#f0f0f0',
                                                            color: item.status === false ? '#721c24' : '#000',
                                                            padding: '4px 8px',
                                                            borderRadius: '4px',
                                                            display: 'inline-block',
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        {highlightText(item.item_name, searchTerm)}
                                                    </span>
                                                    {item.status === false && (
                                                        <small className="ms-2 text-danger" style={{ fontStyle: 'italic', fontSize: '0.85rem' }}>
                                                            (Return generated)
                                                        </small>
                                                    )}
                                                </div>
                                            </td>

                                            <td>{item.quantity}</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className={`form-control ${item.error && item.status !== false ? 'is-invalid' : ''}`}
                                                    value={item.acc_qty}
                                                    max={item.quantity}
                                                    onChange={(e) => handleAccQtyChange(index, e.target.value)}
                                                    disabled={item.status === false}
                                                />
                                                {item.error && item.status !== false && (
                                                    <div className="invalid-feedback">
                                                        {item.error}
                                                    </div>
                                                )}
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={item.rej_qty}
                                                    disabled
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={item.accrej_remarks}
                                                    onChange={(e) => handleRemarksChange(index, e.target.value)}
                                                    disabled={item.status === false}
                                                />
                                            </td>
                                        </tr>
                                    ))
                            )}
                        </tbody>
                    </table>
                </div>
                <div className='text-end mt-3'>
                    <button className='btn btn-primary' onClick={handleSubmit} disabled={disable}>
                        {disable ? "Processing..." : "Submit"}
                    </button>
                </div>
            </div>
        </ModalWrapper>
    )
}

export default AccRejModel